import { ChangeDetectorRef, Directive, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewRef } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';
import { Model } from '@df/catalog/model';
import { Filter } from '@df/catalog-ui/listing/filter/filter';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class FilterComponentDef<T extends Model> implements OnInit, OnChanges, OnDestroy {
    /**
     * Access to app
     */
    @NgInject(App)
    readonly app!: App;

    /**
     * Filter model binding
     */
    filter!: Filter<T>;

    protected canAsync = true;
    protected canDetach = true;

    /**
     * Subscription
     */
    protected listingSubscription?: Subscription;

    constructor(
        private _ref: ChangeDetectorRef,
        protected timeoutService: TimeoutService
    ) {}

    ngOnInit() {
        if (this.canDetach) {
            this._ref.detach();
            this.detectChanges();
        }
    }

    ngOnChanges(changesObj: SimpleChanges) {
        this.unsubscribe();
        if (this.filter) {
            this.listingSubscription = this.filter.listing.subscribe(() => this.onListingUpdate());
        }
    }

    detectChanges() {
        const cb = () => {
            if (!(<ViewRef>this._ref).destroyed) {
                this._ref.detectChanges();
            }
        };
        if (this.canAsync) {
            this.timeoutService.async(cb);
        } else {
            cb();
        }
    }

    ngOnDestroy() {
        this.unsubscribe();
    }

    protected onListingUpdate(): void {
        this.detectChanges();
    }

    unsubscribe() {
        if (this.listingSubscription) {
            this.listingSubscription.unsubscribe();
            this.listingSubscription = undefined;
        }
    }
    canShow(filter: Filter<T>): boolean {
        return filter.hasAnyMatches;
    }
}
